import { PrizesFilterState } from './store/prizes.types';

export const prizesFilterHash = (options: PrizesFilterState['prizes']): string =>
  Object.keys(options ?? {})
    .sort()
    .filter((prizeValue) => options[prizeValue])
    .join('_');
